//#region Util Imports

import * as _ from 'underscore'
import * as $ from 'jquery'

//#endregion

//#region DevExpress Imports


//#endregion


import { ColumnModel } from '../../modules/api/api.models'

import { Enums } from '../../models/common/enums'
import { OpConfigurationProfile } from '../../models/core'

import { ToastHelper, LocalizationHelper, ConvertHelper, LogHelper, ReferenceTypeComponent } from '../../helpers'

import { CreateEditInitParams, } from '../../modules/common/create-edit-popup'

import { USER_SESSION_SERVICE_NAME, UserSessionService } from '../user-session'
import { GridService, GRID_SERVICE_NAME } from '../grid'
import { SYSTEM_SERVICE_NAME, SystemService, DetailsOptions, CreateEditResult, DetailsResult } from '../system'
import { IReferenceType } from '../../models/util/interfaces'
import { ReferenceTypeService, REFERENCE_TYPE_SERVICE_NAME } from '../reference-type'

// #region Consts

export const CONFIGURATION_PROFILE_SERVICE_NAME: string = 'ConfigurationProfileService'
export const PROVIDER_NAME: string = 'ConfigurationProfileProvider'

// #endregion

export class ConfigurationProfileService {

    // #region Consts

    public static get FILE_NAME_PREFIX(): string { return 'configurationProfiles' }
    public static get REFERENCE_TYPE(): Enums.ReferenceType { return Enums.ReferenceType.IdConfigurationProfile }
    public static get SIMAX_MODULE_NAME(): Enums.SimaxModuleName { return Enums.SimaxModuleName.Configuration_Profile }
    public static get LOG_PREFIX(): string { return '[SIMAX.Module.ConfigurationProfile]' }

    // #endregion

    // #region Ctor

    constructor(
        private readonly gridService: GridService,
        private readonly systemService: SystemService,
        private readonly userSessionService: UserSessionService,
        private readonly referenceTypeService: ReferenceTypeService
    ) { }

    // #endregion

    // #region Methods

    public getConfigurationProfile(id: number): JQueryPromise<OpConfigurationProfile> {
        return this.userSessionService
            .getDataProvider()
            .ConfigurationProfile
            .getConfigurationProfile(id)
            .then((profile: OpConfigurationProfile) => {
                return profile
            })
    }


    public deleteConfigurationProfile(idConfigurationProfile: number): JQueryPromise<void> {
        const deferred: JQueryDeferred<void> = $.Deferred<void>()

        this.userSessionService
            .getDataProvider()
            .ConfigurationProfile
            .deleteConfigurationProfile(idConfigurationProfile)
            .then(() => {
                ToastHelper.showSuccess(LocalizationHelper.getLocalizedTextByModule(Enums.SimaxLocalizationCategory._MODULE_NAME__DELETED, ConfigurationProfileService.SIMAX_MODULE_NAME))
                deferred.resolve()
            })
            .fail((error: any) => {

                ToastHelper.showError(ConvertHelper.getRequestErrorMessage(error) || LocalizationHelper.getLocalizedText(LocalizationHelper.Text.ExceptionOccuredPleaseContactAnAdministrator))
                LogHelper.warn(ConfigurationProfileService.LOG_PREFIX, `Unnable to delete configuration profile with id ${idConfigurationProfile}`, error)

                deferred.resolve(error)
            })

        return deferred.promise()
    }

    public saveConfigurationProfile(configurationProfile: OpConfigurationProfile): JQueryPromise<OpConfigurationProfile> {
        const deferred: JQueryDeferred<OpConfigurationProfile> = $.Deferred<OpConfigurationProfile>()

        this.userSessionService
            .getDataProvider()
            .ConfigurationProfile
            .saveConfigurationProfile(configurationProfile)
            .then((savedObject: OpConfigurationProfile) => {
                ToastHelper.showSuccess(LocalizationHelper.getLocalizedTextByModule(Enums.SimaxLocalizationCategory._MODULE_NAME__SAVED, ConfigurationProfileService.SIMAX_MODULE_NAME))

                deferred.resolve(savedObject)
            })
            .fail((error: any) => {
                ToastHelper.showError(ConvertHelper.getRequestErrorMessage(error) || LocalizationHelper.getLocalizedText(LocalizationHelper.Text.ExceptionOccuredPleaseContactAnAdministrator))
                LogHelper.warn(ConfigurationProfileService.LOG_PREFIX, `Unnable to save configuration profile with id ${configurationProfile.idConfigurationProfile}`, error)

                deferred.reject(error)
            })

        return deferred.promise()
    }


    // #endregion

    //#region CreateEdit

    public openCreate(templateId: number = null, targetConfigurationProfile: OpConfigurationProfile = null): JQueryPromise<CreateEditResult<OpConfigurationProfile>> {
        const createEditOptions: CreateEditInitParams = this.getCreateEditOptions(templateId || 0, undefined, undefined, !!templateId)

        return this.systemService.openCreateEdit<OpConfigurationProfile>(createEditOptions);
    }

    public openEdit(idConfigurationProfile: number): JQueryPromise<CreateEditResult<OpConfigurationProfile>> {
        const createEditOptions: CreateEditInitParams = this.getCreateEditOptions(idConfigurationProfile)

        return this.systemService.openCreateEdit<OpConfigurationProfile>(createEditOptions);
    }

    public getCreateEditOptions(referenceObjectId: number = 0,
        referenceObject: OpConfigurationProfile = null,
        selectedTabType: Enums.SimaxCreateEditSelectedTabType = Enums.SimaxCreateEditSelectedTabType.BaseParameters,
        isCopy: boolean = false
    ): CreateEditInitParams {
        return {
            createEditSelectedTabType: selectedTabType,
            groupReferenceType: Enums.ReferenceType.IdConfigurationProfile,
            groupReferenceValue: referenceObjectId,
            idReferenceType: ConfigurationProfileService.REFERENCE_TYPE,
            moduleName: ConfigurationProfileService.SIMAX_MODULE_NAME,
            referenceObject: null,
            referenceObjectId: referenceObjectId,
            sections: null,
            useBusinessObjects: true,
            isCopy: isCopy
        }
    }

    //#endregion

    //#region Details

    public openDetails(idConfigurationProfile: number, pageItemsIds: number[]): JQueryPromise<DetailsResult> {
        const detailsOptions: DetailsOptions = this.getDetailsOptions(idConfigurationProfile);

        detailsOptions.pageItemsIds = pageItemsIds;

        return this.systemService.openDetails(detailsOptions);
    }

    public getDetailsOptions(idConfigurationProfile: number): DetailsOptions {
        return {
            hasPermission: true,
            idReferenceType: Enums.ReferenceType.IdConfigurationProfile,
            moduleName: ConfigurationProfileService.SIMAX_MODULE_NAME,
            pageItemsIds: null,
            referenceObjectId: idConfigurationProfile,
        }
    }

    //#endregion

    // #region Options
    public getMainGridColumns(): JQueryPromise<ColumnModel[]> {
        return this.gridService
            .getColumnModelByCategory(
                [
                    Enums.SimaxDataTypeGroupCategory.WEBSIMAX__MODULE_NAME__GRID_PARAMS,
                    Enums.SimaxDataTypeGroupCategory.WEBSIMAX__MODULE_NAME__DEFAULT_GRID_PARAMS
                ],
                ConfigurationProfileService.SIMAX_MODULE_NAME,
                {
                    groupReferenceType: Enums.ReferenceType.IdDistributor,
                    groupReferenceValue: this.userSessionService.getLoggedOperator().idDistributor
                }
            )
    }

    // #endregion

    //#region Utils


    //#endregion

}

export class ConfigurationProfileServiceProvider implements ng.IServiceProvider {

    // #region IServiceProvider Implementation 

    public $get = [GRID_SERVICE_NAME, SYSTEM_SERVICE_NAME, USER_SESSION_SERVICE_NAME, REFERENCE_TYPE_SERVICE_NAME, function (gridService: GridService, systemService: SystemService, userSession: UserSessionService, referenceTypeService: ReferenceTypeService) {
        return new ConfigurationProfileService(gridService, systemService, userSession, referenceTypeService)
    }]

    // #endregion
}